import { at } from 'lodash-es';

export const getJsonPathValue = (
  json: Record<string, unknown>,
  jsonPath: string
) => {
  const [value] = jsonPath === '' ? [json] : at(json, jsonPath);

  if (value === undefined) {
    throw new Error(`No value found for the JSON path ${jsonPath}`);
  }

  return value;
};
